import React from "react";
import "./App.scss";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home/HomePage.js";
import Enroll from "./pages/Enroll/EnrollPage.js";
import Confirmation from "./pages/Enroll/ConfirmationPage.js";
import useDatadog from "react-datadog";

export default function App() {
	useDatadog({
		clientToken: "pub40dd32a6fc77cae302baea1a6b229d8c",
		applicationId: "187a50dd-e25e-412e-b5cf-8496f6ded1fd",
		// `site` refers to the Datadog site parameter of your organization
		// see https://docs.datadoghq.com/getting_started/site/
		site: "datadoghq.com",
		service: "bmw-regional-digital-prd",
		env: "prod",
		// Specify a version number to identify the deployed version of your application in Datadog
		// version: '1.0.0',
		sessionSampleRate: 100,
		sessionReplaySampleRate: 100,
		trackUserInteractions: true,
		trackResources: true,
		trackLongTasks: true,
		defaultPrivacyLevel: "allow",
	});

	return (
		<div className="App">
			<Router>
				<Routes>
					<Route path="/" element={<Home />} />
					<Route path="/enroll" element={<Enroll />} />
					<Route path="/confirmation" element={<Confirmation />} />
				</Routes>
			</Router>
		</div>
	);
}
